export class ErrorConstants{

    public static CREATE_LEAD = 'ER001';
    public static UPDATE_LEAD = 'ER002';
    public static GET_UNIQUE_LINK_EI = 'ER003';
    public static SEARCH_EI = 'ER004';
    public static SEND_LINK_EMAIL = 'ER005';
    public static RECAPTCHA = 'ER006';
    public static GET_EI_FROM_GROUP = 'ER007';
    public static UPDATE_LEAD_STATUS = 'ER008';

}